<div class="spinner-panel" *ngIf="loading">
  <mat-spinner></mat-spinner>
</div>
<div class="versions-content" [style.display]="loading ? 'none' : 'flex'">
  <wk-select label="{{ 'APP.ACTIONS.COMPARE_AND_MERGE' | translate }}">
    <select
      #current
      class="wk-field-select"
      [(ngModel)]="currentVersion"
      (ngModelChange)="onVersionChange()"
      id="current-version-tooltip"
    >
      <option [value]="null">
        {{ 'APP.ACTIONS.SELECT_VERSION_TO_COMPARE' | translate }}
      </option>
      <option
        *ngFor="let option of currentVersions"
        [ngValue]="option"
        [attr.title]="option.title"
      >
        {{
          option.title.length <= 70
            ? option.title
            : option.title.substr(0, 70) + '...'
        }}
      </option>
    </select>
  </wk-select>

  <span
    title="swap-horizontal"
    class="wk-icon-swap-horizontal"
    (click)="swap()"
    (keyup)="swap()"
  ></span>

  <wk-select label="With">
    <select
      class="wk-field-select"
      [(ngModel)]="targetVersion"
      (ngModelChange)="onVersionChange()"
      id="target-version-tooltip"
    >
      <option [value]="null">
        {{ 'APP.ACTIONS.SELECT_VERSION_TO_COMPARE' | translate }}
      </option>
      <option
        *ngFor="let option of targetVersions"
        [ngValue]="option"
        [attr.title]="option.title"
      >
        {{
          option.title.length <= 70
            ? option.title
            : option.title.substr(0, 70) + '...'
        }}
      </option>
    </select>
  </wk-select>
</div>

<wk-tooltip
  *ngIf="currentVersion"
  type="description"
  position="bottom"
  target-selector="#current-version-tooltip"
>
  <p slot="body">
    {{
      currentVersion?.number +
        ' ' +
        file.name +
        ' ' +
        currentVersion?.checkedIn +
        ' ' +
        currentVersion?.createdBy
    }}
  </p>
</wk-tooltip>
<wk-tooltip
  *ngIf="targetVersion"
  type="description"
  position="bottom"
  target-selector="#target-version-tooltip"
>
  <p slot="body">
    {{
      targetVersion?.number +
        ' ' +
        file.name +
        ' ' +
        targetVersion?.checkedIn +
        ' ' +
        targetVersion?.createdBy
    }}
  </p>
</wk-tooltip>
